/**
 * StringValidation is a collection of static methods for validating strings.
 * The most common use case is to validate user input for forms.
 *
 * The constructor is marked private to prevent instantiation from outside the class,
 * mimicking a static class pattern commonly used in other languages.
 * All methods are defined as static and should be accessed directly
 * via the class (e.g., StringValidation.isStringEmpty(...)).
 */
class StringValidation {
    private constructor() {
        return
    }

    static isEmpty(str: string): boolean {
        return str.length === 0
    }
}

export { StringValidation }
